import {
  Tooltip,
  TooltipTrigger,
  TooltipPopup,
  Icon,
  Text,
} from "@salestrak/ui";

interface InfoTooltipProps {
  children: React.ReactNode;
}

const TOOLTIP_MAX_WIDTH = { maxWidth: 240 } as const;

export function InfoTooltip({ children }: InfoTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger>
        <Icon name="info" size="md" color="muted" />
      </TooltipTrigger>
      <TooltipPopup side="top" style={TOOLTIP_MAX_WIDTH}>
        <Text size="xs">{children}</Text>
      </TooltipPopup>
    </Tooltip>
  );
}
